module.exports = __webpack_public_path__ + "media/scale.4c903187.mp4";